import { styled } from 'styled-components';

import { theme } from '../../styles';
import { ResponsiveSpacing } from '../../utils';
import { Headings } from '../Headings';
import { Container, Grid } from '../Layout';
import { useMediaMin } from '../Media';
import { Text } from '../Text';

export type PageHeroProps = {
  title: string;
  subtitle: string;
  renderIcon: JSX.Element;
  eService?: boolean;
  onStartPage?: boolean;
  flyingIcon?: boolean;
  guide?: boolean;
  height?: number;
  paddingBottom?: ResponsiveSpacing;
};

const GuideIcon = styled.span`
  background-color: ${theme.colors.amber};
  width: fit-content;
  padding: 0rem 0.1875rem 0rem 0.1875rem;
  border-radius: 0.125rem;
  font-size: 0.875rem;
  font-weight: 600;
`;

const GuideIconContainer = styled.span<{ isDesktop: boolean }>`
  justify-content: ${props => (props.isDesktop ? 'center' : 'start')};
  margin-top: ${props => (props.isDesktop ? '0rem' : '1.25rem')};
  color: ${theme.colors.foraBlue};
  margin-bottom: ${props => (props.isDesktop ? '0rem' : '-0.625rem')};
`;

export const PageHero = ({
  title,
  subtitle,
  renderIcon,
  eService,
  onStartPage,
  flyingIcon = false,
  guide = false,
  height = 400,
  paddingBottom = [0, 0, 50],
}: PageHeroProps) => {
  const isDesktop = useMediaMin(theme.breakpoint.lg);
  return (
    <Container backgroundColor="foraBlue" style={{ borderBottom: `4px solid ${theme.colors.darkBlue}` }}>
      <Container
        marginLeft="auto"
        marginRight="auto"
        paddingTop={[26, 20, 0]}
        paddingBottom={eService ? [80, 90, 0] : onStartPage ? [80, 90, 100] : [40, 40, 0]}
        maxWidth={1236}
        height={['auto', 'auto', onStartPage ? 510 : height]}
      >
        <Grid gutterWidth={40} sidePadding={[20, 46, 20]} height="100%">
          <Grid.Row>
            <Grid.Col
              xs={12}
              md={10}
              lg={6}
              push={{ md: 1 }}
              flexOrder={[2, 2, 1]}
              textAlign={['center', 'center', 'left']}
              verticalAlign="center"
              paddingBottom={eService ? paddingBottom : 0}
            >
              {guide && (
                <GuideIconContainer isDesktop={isDesktop}>
                  <GuideIcon>GUIDE</GuideIcon>
                </GuideIconContainer>
              )}

              <Headings.H1 marginBottom={[20, 20, 10]} marginTop={[20, 10, 0]} color="white">
                {title}
              </Headings.H1>
              <Text size="large" color="white">
                {subtitle}
              </Text>
            </Grid.Col>
            <Grid.Col
              xs={12}
              lg={4}
              push={{ lg: 1 }}
              flexOrder={[1, 1, 2]}
              horizontalAlign="center"
              verticalAlign={flyingIcon ? 'center' : 'flex-end'}
            >
              {renderIcon}
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </Container>
    </Container>
  );
};
